import { createSelector } from "reselect";
import { AppState } from "src/shared/interfaces/State.interface";

const selectAlert = (state: AppState) => state.alert;

export const getAlerts = () => createSelector(selectAlert, (state) => state.alerts);
export const getAlertsTotal = () => createSelector(selectAlert, (state) => state.alertsTotal);
export const getAlert = () => createSelector(selectAlert, (state) => state.currentAlert);
export const getFilter = () => createSelector(selectAlert, (state) => state.filter);
